import React from 'react';
import clsx from 'clsx';
import type { EmptyStateProps } from '../../types/ui';

const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  title,
  description,
  action,
  compact = false,
}) => (
  <div
    className={clsx(
      'flex flex-col items-center justify-center text-center',
      compact ? 'px-4 py-8' : 'px-6 py-14'
    )}
  >
    <div className='mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-primary-50 text-primary-600 dark:bg-primary-950 dark:text-primary-300'>
      <Icon className='h-6 w-6' aria-hidden='true' />
    </div>
    <h3 className='font-semibold text-secondary-900 dark:text-white'>{title}</h3>
    {description ? (
      <p className='mt-1 max-w-md text-sm leading-6 text-secondary-500 dark:text-secondary-400'>
        {description}
      </p>
    ) : null}
    {action ? <div className='mt-5'>{action}</div> : null}
  </div>
);

export default EmptyState;
